import React, { useState, useEffect, useRef } from "react";
import { useNavigate, useParams, Link } from "react-router-dom";
import axios from "axios";
import Response_Processing from "../../../../src/layout/Others/Response_Processing";
import JoditEditor from "jodit-react";
import AdminSaveHeader from "../../../components/CommonComponents/AdminSaveHeader";
import { CiShare1 } from "react-icons/ci";
import { MdAdd, MdOutlineRemoveCircle, MdCheck } from "react-icons/md";
import { BsCurrencyExchange } from "react-icons/bs";
import { getItemToken } from "../../../../src/Utils/localStorageUtils";
import { toast } from "react-toastify";
import FormContainer from "../../../components/CommonComponents/FormContainer";
import LeftWrapper from "../../../components/CommonComponents/LeftWrapper";
import Wrapper from "../../../components/CommonComponents/Wrapper";
import MessageHeading from "../../../components/CommonComponents/MessageHeading";
import MessageLabel from "../../../components/CommonComponents/MessageLabel";
import MessageSubHeading from "../../../components/CommonComponents/MessageSubHeading";
import AdminCustomInput from "../../../components/CommonComponents/AdminCustomInput";
import AdminSwitch from "../../../components/CommonComponents/AdminSwitch";
import RightWrapper from "../../../components/CommonComponents/RightWrapper";
import Select from "react-select";
import AdminCustomRadio from "../../../components/CommonComponents/AdminCustomRadio";
import MessageBox from "../../../components/CommonComponents/MessageBox";
import AdminCustomSelect from "../../../components/CommonComponents/AdminCustomSelect";
import AdminCheckBox from "../../../components/CommonComponents/AdminCheckBox";
import AdminCustomButton from "../../../components/CommonComponents/AdminCustomButton";
import AdminBackNavigation from "../../../components/CommonComponents/AdminBackNavigation";
import stripe_image from "../../../components/Images/payment_logo/stripe.svg";
import paypal_image from "../../../components/Images/payment_logo/paypal.svg";
import razorpay_image from "../../../components/Images/payment_logo/razorpay.svg";
import applepay_image from "../../../components/Images/payment_logo/applepay.svg";
import googlepay_image from "../../../components/Images/payment_logo/googlepay.svg";
import iyzico_image from "../../../components/Images/payment_logo/iyzico.svg";
import pesapal_image from "../../../components/Images/payment_logo/pesapal.svg";
import payhere_image from "../../../components/Images/payment_logo/PayHere.svg";
import cashfree_image from "../../../components/Images/payment_logo/cashfree.svg"
import ideabiz_image from "../../../components/Images/payment_logo/ideabiz.png"
import { useMyContext } from "../../../components/Provider/CommonProvider";
import { IoMdInformationCircle } from "react-icons/io";

const AddSubscriptionPlan = (props) => {

  const { fetchRequest } = useMyContext()

  const navigate = useNavigate();
  const baseURL = process.env.REACT_APP_Baseurl
  const headers = getItemToken('access_token')
  const { id } = useParams()
  const labelSource = 'subscription-plan'

  const createApi = `${baseURL}/admin/subscription/create`
  const previewApi = `${baseURL}/admin/subscription/preview/${id}`
  const updateApi = `${baseURL}/admin/subscription/update`
  const addApi = `${baseURL}/admin/subscription/store_plan`
  const labelApi = `${baseURL}/admin/Label-Management/list-source?source=${labelSource}`
  const currencyDefault = `${baseURL}/admin/currency_setting/index`
  const combinedRef = useRef({
    plans_name: null,
    billing_interval: null,
    billing_type: null
  });

  const [formData, setFormData] = useState({
    state: "formData",
    plans_name: "",
    billing_interval: "",
    billing_type: "Non-Refundable",
    ads_status: 0,
    plan_trail_status: 0,
    status: 1,
    payment_type: "recurring",
    plan_trail_days: null,
    currency: "",
    stripe_enable: 0,
    iyzico_enable: 0,
    razorpay_enable: 0,
    devices: "",
    defaultDeviceLimitOptions: [
      { name: "Total Devices (Any Platform)", value: "total_limit" },
      { name: "Platform & Device Combination", value: "platform_device_combination" },
      { name: "Per Platform Limit", value: "individual_limit" },
    ],
    individualDevicesList: [{ label: "Laptop/Windows", value: "web" }, { label: "Mobile", value: "mobile" }, { label: "Tablet", value: "tablet" }, { label: "TV", value: "tv" }],
    devices_count: 0,
    individual_limits: { web: 1, mobile: 1, tablet: 1, tv: 1 },
    paypal_enable: 0,
    pesapal_enable: 0,
    payhere_enable: 0,
    cashfree_enable: 0,
    applepay_enable: 0,
    googlepay_enable: 0,
    ideabiz_enable: 0,
    ideabiz_plan_id: "",
    google_pay_product_id: "",
    google_pay_plan_price: "",
    plan_content: "",
    selected_source_types: [],
    common_days: '',
    plan_category: '',
    restriction_source_types_days: {},
    premium_content: 0,
    music: 0,
    live_tv: 0,
    max_audio_quality: "",
    device_limit: 0,
    secondary_prices: {},
    plan_based_video: 0,
    plan_contents: [],
    coupon_gateways: [],
  })
  const [defaultOption, setDefaultOption] = useState({
    state: "defaultOption",
    devicesOption: [],
    paymentOption: [],
    resolutionOption: [],
    intervalOption: [],
    sourceTypesOption: [],
    currencyOption: []
  })

  const categoryOptions = [
    { name: "Subscription", value: 1 },
    { name: "Pay Per Views (PPV)", value: 2 },
    { name: "Partner Subscription", value: 3 },
    { name: "Ads Subscription", value: 4 },
  ];

  const subscription_devices = [
    { id: 1, devices_name: "Laptop/Desktop", devices: "Laptop/Desktop", devices_type: "web", active: 1 },
    { id: 2, devices_name: "Mobile", devices: "Mobile", devices_type: "mobile", active: 1 },
    { id: 3, devices_name: "Tablet", devices: "Tablet", devices_type: "tab", active: 1 },
    { id: 4, devices_name: "TV", devices: "TV", devices_type: "tv", active: 1 },
  ];

  const [labelDisplay, setLabelDisplay] = useState([]);
  const [withOutRefresh, setWithOutRefresh] = useState(false)
  const [showOverlay, setShowOverlay] = useState(false);
  const [formDataError, setFormDataError] = useState({})
  const [symbol, setSymbol] = useState("");

  // ── Plan-Based-Video content search state ────────────────────────────────
  const planContentSearchApi = `${baseURL}/admin/subscription/plan-content-search`;
  const [pbvSearchQuery, setPbvSearchQuery] = useState('');
  const [pbvSearchResults, setPbvSearchResults] = useState([]);
  const [pbvSearchLoading, setPbvSearchLoading] = useState(false);
  const pbvSearchTimerRef = React.useRef(null);

  const CONTENT_TYPE_OPTIONS = [
    { value: 1, label: 'Video' },
    { value: 2, label: 'Livestream' },
    { value: 3, label: 'Series' },
    { value: 4, label: 'Episode' },
    { value: 5, label: 'Audio' },
  ];
  const [pbvSelectedTypes, setPbvSelectedTypes] = useState([1]); // default: Video

  const handlePbvSearch = async (query, types) => {
    if (!query || query.trim().length < 2) { setPbvSearchResults([]); return; }
    setPbvSearchLoading(true);
    try {
      const res = await axios.post(planContentSearchApi, { query: query.trim(), source_types: types }, { headers });
      setPbvSearchResults(res?.data?.data || []);
    } catch {
      setPbvSearchResults([]);
    } finally {
      setPbvSearchLoading(false);
    }
  };

  const handlePbvQueryChange = (e) => {
    const q = e.target.value;
    setPbvSearchQuery(q);
    if (pbvSearchTimerRef.current) clearTimeout(pbvSearchTimerRef.current);
    pbvSearchTimerRef.current = setTimeout(() => handlePbvSearch(q, pbvSelectedTypes), 350);
  };

  const handlePbvTypeToggle = (typeValue) => {
    const updated = pbvSelectedTypes.includes(typeValue)
      ? pbvSelectedTypes.filter(t => t !== typeValue)
      : [...pbvSelectedTypes, typeValue];
    setPbvSelectedTypes(updated);
    if (pbvSearchTimerRef.current) clearTimeout(pbvSearchTimerRef.current);
    pbvSearchTimerRef.current = setTimeout(() => handlePbvSearch(pbvSearchQuery, updated), 100);
  };

  const handleAddPbvContent = (item) => {
    setFormData(prev => {
      const already = prev.plan_contents.some(c => c.source_id === item.id && c.source_type === item.source_type);
      if (already) return prev;
      return { ...prev, plan_contents: [...prev.plan_contents, { source_id: item.id, source_type: item.source_type, title: item.title }] };
    });
  };

  const handleRemovePbvContent = (source_id, source_type) => {
    setFormData(prev => ({
      ...prev,
      plan_contents: prev.plan_contents.filter(c => !(c.source_id === source_id && c.source_type === source_type)),
    }));
  };

  const sourceTypeLabel = (type) => CONTENT_TYPE_OPTIONS.find(o => o.value === type)?.label || 'Unknown';
  // ── End plan-based-video state ────────────────────────────────────────────

  const imageFind = {
    1: stripe_image,
    2: paypal_image,
    3: razorpay_image,
    4: iyzico_image,
    5: applepay_image,
    6: pesapal_image,
    7: payhere_image,
    8: cashfree_image,
    9: googlepay_image,
    10: ideabiz_image,
  }

  const multiSelectLabel = (array, valueKey, labelKey) => {
    return Array.isArray(array) ? array?.map((item) => ({
      value: item[valueKey],
      label: item[labelKey]
    })) : [];
  };


  const handleMultiSelect = (selectedOptions, actionMeta) => {
    console.log(`actionMeta ${JSON.stringify(actionMeta, null, 2)} and selectedOptions ${JSON.stringify(selectedOptions)}`);

    setFormData((prev) => ({
      ...prev,
      [actionMeta.name]: selectedOptions
    }))
    setFormDataError((prev) => ({
      ...prev,
      [actionMeta.name]: ""
    }))
  }

  const handleSourceTypeSelect = (selectedOptions) => {
    console.log('DEBUG: Selected source types:', selectedOptions);
    setFormData((prev) => ({
      ...prev,
      selected_source_types: selectedOptions || []
    }));
    setFormDataError(prev => ({ ...prev, selected_source_types: '' }));
  };

  const handleCommonDaysChange = (value) => {
    console.log(`DEBUG: Updating common days with value ${value}`);
    setFormData(prev => ({
      ...prev,
      common_days: value
    }));
    setFormDataError(prev => ({ ...prev, common_days: '' }));
  };

  // Toggle a gateway ID in/out of the coupon_gateways array
  const handleCouponGatewayToggle = (gatewayId) => {
    setFormData(prev => {
      const current = Array.isArray(prev.coupon_gateways) ? prev.coupon_gateways : [];
      const updated = current.includes(gatewayId)
        ? current.filter(id => id !== gatewayId)
        : [...current, gatewayId];
      return { ...prev, coupon_gateways: updated };
    });
  };


  const handleInput = (e) => {
    const { name, value, type, checked, id } = e.target;

    if (type === "checkbox") {
      // if (name === "devices") {
      //   setFormData(prev => ({
      //     ...prev,
      //     [name]: checked ? "total_limit" : "individual_limit",
      //     devices_count: checked ? prev.devices_count || 1 : prev.devices_count,
      //     individual_limits: !checked ? prev.individual_limits || { web: 1, mobile: 1, tablet: 1, tv: 1 } : prev.individual_limits
      //   }))
      // } else {
      //   setFormData((prev) => ({
      //     ...prev,
      //     [name]: checked ? 1 : 0,
      //   }));
      // }
      setFormData((prev) => ({
        ...prev,
        [name]: checked ? 1 : 0,
      }));
    }

    if (type === 'radio') {
      setFormData((prev) => ({
        ...prev,
        [name]: value,
      }));
    }

    if (type === 'select-one') {
      setFormData((prev) => ({
        ...prev,
        [name]: value,
      }));
      setFormDataError((prev) => ({
        ...prev,
        [name]: '',
      }));
      if (name === 'currency') {
        const selected = defaultOption?.currencyOption?.find(item => item.code === value);
        if (selected) {
          setSymbol(selected.symbol);
        }
      }
    }

    if (type === "number") {
      const cleanedValue = value.replace(/[^0-9.-]/g, '');
      let finalValue = cleanedValue === "" ? null : Number(cleanedValue);
      if (isNaN(finalValue)) {
        finalValue = null;
      }
      setFormData((prev) => ({
        ...prev,
        [name]: finalValue
      }));
      if (finalValue === "" || finalValue === null) {
        setFormDataError((prev) => ({
          ...prev,
          [name]: 'This field is required and should contain a valid number.',
        }));
      } else {
        setFormDataError((prev) => ({
          ...prev,
          [name]: '',
        }));
      }
    }

    if (type === 'text') {
      setFormData((prev) => ({
        ...prev,
        [name]: value,
      }));
      setFormDataError((prev) => ({
        ...prev,
        [name]: '',
      }));
    }
  };

  const handleDeviceLimitChange = (e) => {
    const { name, value } = e.target;

    setFormData(prev => ({
      ...prev,
      individual_limits: {
        ...prev.individual_limits,
        [name]: Number(value),
      },
    }));
  };


  const handleInputUpdate = (e) => {
    const { name, value, type, checked, id } = e.target;

    if (type === "checkbox") {
      if (name === "devices") {

        let deviceIds = (formData?.devices || "")
          .split(",")
          .filter((val) => val);
        const index = deviceIds.findIndex((val) => val === id.toString());
        if (index !== -1) {
          deviceIds.splice(index, 1);
        } else {
          deviceIds.push(id.toString());
        }
        const devices = deviceIds.length > 0 ? deviceIds.join(",") : "";
        setFormData({ ...formData, devices });
        setFormDataError((prevFormData) => ({
          ...prevFormData,
          devices: "",
        }));
      }
      else {
        setFormData((prev) => ({
          ...prev,
          [name]: checked ? 1 : 0,
        }));
      }
    }

    if (type === 'select-one') {
      setFormData((prev) => ({
        ...prev,
        [name]: value,
      }));
      setFormDataError((prev) => ({
        ...prev,
        [name]: '',
      }));
    }

    if (type === "number") {
      const cleanedValue = value.replace(/[^0-9.-]/g, '');
      const finalValue = cleanedValue === "" ? null : Number(cleanedValue);
      setFormData((prev) => ({
        ...prev,
        [name]: finalValue
      }));
      if (finalValue === "" || finalValue === null) {
        setFormDataError((prev) => ({
          ...prev,
          [name]: 'This field is required and should contain a valid number.',
        }));
      } else {
        setFormDataError((prev) => ({
          ...prev,
          [name]: '',
        }));
      }
    }

    if (type === 'text') {
      setFormData((prev) => ({
        ...prev,
        [name]: value,
      }));
      setFormDataError((prev) => ({
        ...prev,
        [name]: '',
      }));
    }
  };


  const handleDeviceCountChange = (e) => {
    const { name, value } = e.target;
    if (value === '' || (/^\d+$/.test(value) && +value <= 99 && +value >= 1)) {
      setFormData((prevFormData) => ({
        ...prevFormData,
        [name]: value,
      }));
      setFormDataError((prevError) => ({
        ...prevError,
        [name]: "",
      }));
    }
  };


  const labelFetch = async () => {
    try {
      setShowOverlay(true)
      const response = await axios.get(`${labelApi}`, { headers: headers });
      const result = response?.data?.label_management
      setLabelDisplay(result)
      setShowOverlay(false)
    }
    catch (err) {
      setShowOverlay(false)
      toast.error(err.response.data.message)

    }
  }

  const formValidation = () => {
    let formIsValid = true;
    if (!formData?.plans_name || formData.plans_name.trim().length < 3) {
      setFormDataError((prevFormData) => ({
        ...prevFormData,
        plans_name: formData?.plans_name
          ? "Plan Name must be at least 3 characters."
          : "Plan Name cannot be empty.",
      }));
      combinedRef.current['plans_name'].focus()
      formIsValid = false;
    }

    const plainTextContent = formData.plan_content.replace(/<[^>]+>/g, '').trim();

    if (plainTextContent.length > 500) {
      setFormDataError((prevFormData) => ({
        ...prevFormData,
        plan_content: "Plan content must not exceed 500 characters.",
      }));
      combinedRef.current['plan_content'].focus();
      formIsValid = false;
    }

    if (!formData?.billing_interval) {
      setFormDataError((prevFormData) => ({
        ...prevFormData,
        billing_interval: "Billing Interval cannot be empty.",
      }));
      combinedRef.current['billing_interval'].focus()
      formIsValid = false;
    }
    if (!formData?.billing_type) {
      setFormDataError((prevFormData) => ({
        ...prevFormData,
        billing_type: "Billing Type cannot be empty.",
      }));
      combinedRef.current['billing_type'].focus()
      formIsValid = false;
    }
    // if (!formData?.days) {
    //   setFormDataError((prevFormData) => ({
    //     ...prevFormData,
    //     days: "Days cannot be empty.",
    //   }));
    //   combinedRef.current['days'].focus()
    //   formIsValid = false;
    // }
    if (formData?.price === "" || formData?.price === null || formData?.price === undefined) {
      setFormDataError((prevFormData) => ({
        ...prevFormData,
        price: "Price cannot be empty.",
      }));
      combinedRef.current['price'].focus()
      formIsValid = false;
    }
    if (!formData?.video_quality || formData?.video_quality?.length === 0) {
      setFormDataError((prevFormData) => ({
        ...prevFormData,
        video_quality: "Choose video quality.",
      }));
      combinedRef.current['video_quality'].focus()
      formIsValid = false;
    }

    const selectedDeviceIds = (formData?.devices || "")
      .split(",")
      .filter((id) => id);
    console.log(selectedDeviceIds)

    // Handle device count validation differently for create vs update mode
    // if (selectedDeviceIds.length > 0) {
    //   if (id) {
    //     // Update mode - devices_count is a comma-separated string
    //     const deviceCounts = (formData?.devices_count || "")
    //       .split(",");

    //     for (let i = 0; i < selectedDeviceIds.length; i++) {
    //       const count = deviceCounts[i];
    //       if (count === "" || count === undefined || count === null || isNaN(count) || Number(count) <= 0) {
    //         setFormDataError((prevFormData) => ({
    //           ...prevFormData,
    //           devices: "Please enter valid device counts for all selected devices.",
    //         }));
    //         formIsValid = false;
    //         break;
    //       }
    //     }
    //   } else {
    //     // Create mode - devices_count stored as individual fields
    //     for (let deviceId of selectedDeviceIds) {
    //       const fieldName = `devices_count_${deviceId}`;
    //       const count = formData[fieldName];

    //       if (count === "" || count === undefined || count === null || isNaN(count) || Number(count) <= 0) {
    //         setFormDataError((prevFormData) => ({
    //           ...prevFormData,
    //           [fieldName]: "Please enter a valid device count.",
    //         }));
    //         formIsValid = false;

    //         const ref = combinedRef.current?.[fieldName];
    //         if (ref) ref.focus();
    //       }
    //     }
    //   }
    // }

    if (formData?.plan_trail_status == 1 && (formData?.plan_trail_days === "" || formData?.plan_trail_days === null || formData?.plan_trail_days === undefined)) {
      setFormDataError((prevFormData) => ({
        ...prevFormData,
        plan_trail_days: "Plan Trail Days cannot be empty.",
      }));
      combinedRef.current['plan_trail_days'].focus()
      formIsValid = false;
    }

    // Validate Ideabiz Plan ID when Ideabiz payment gateway is enabled
    if (formData?.ideabiz_enable == 1 && (!formData?.ideabiz_plan_id || formData?.ideabiz_plan_id.trim() === '')) {
      setFormDataError((prevFormData) => ({
        ...prevFormData,
        ideabiz_plan_id: "Ideabiz Plan ID cannot be empty when Ideabiz payment is enabled.",
      }));
      combinedRef.current['ideabiz_plan_id']?.focus()
      formIsValid = false;
    }

    if (!formIsValid) {
      console.log('DEBUG: Form validation failed. Current state:', formData);
      console.log('DEBUG: Form validation errors:', JSON.stringify(formDataError));

      // Toast the first error found
      const firstError = Object.values(formDataError).find(msg => msg !== '');
      if (firstError) {
        toast.error(`Validation Error: ${firstError}`);
      } else {
        toast.error("Please check all required fields.");
      }
    }
    return formIsValid;
  }

  const FetchCurrency = async () => {
    try {
      const response = await axios.get(`${currencyDefault}`, { headers: headers });
      const result = response?.data;
      if (result?.CurrencySetting?.symbol) {
        setSymbol(result?.CurrencySetting?.symbol);
      }

      // Parse secondary currencies from JSON string
      const rawSecondary = result?.CurrencySetting?.secondary_currencies;
      const parsedSecondary = rawSecondary
        ? (typeof rawSecondary === 'string' ? JSON.parse(rawSecondary) : rawSecondary)
        : [];

      setDefaultOption((prev) => ({
        ...prev,
        currencyOption: result?.allCurrency,
        enable_secondary_currency: result?.CurrencySetting?.enable_secondary_currency,
        secondary_currencies: parsedSecondary,
      }));

      // Set default currency if creating new plan and not already set
      if (!id && result?.CurrencySetting?.code) {
        setFormData((prev) => {
          if (!prev.currency) {
            return {
              ...prev,
              currency: result?.CurrencySetting?.code
            };
          }
          return prev;
        });
      }
    } catch (error) {
      console.log(error);
    }
  }

  const handleSecondaryPriceChange = (currencyCode, value) => {
    setFormData((prev) => ({
      ...prev,
      secondary_prices: {
        ...prev.secondary_prices,
        [currencyCode]: value
      }
    }));
  };

  const fetchCreate = async () => {
    try {
      const response = await axios.get(`${createApi}`, { headers: headers });
      const result = response?.data;
      const defaultoptionslist = {
        resolutionOption: await multiSelectLabel(result?.resolution, 'value', 'name'),
        paymentOption: result?.PaymentSetting,
        devicesOption: subscription_devices,
        intervalOption: result?.interval,
        sourceTypesOption: await multiSelectLabel(result?.SourceTypes, 'source_types_id', 'source_types_name')
      }
      // Map payment settings dynamically by type to avoid index issues
      const paymentMap = {};
      result?.PaymentSetting?.forEach(payment => {
        if (payment?.type) {
          paymentMap[payment.type] = payment.status || 0;
        }
      });

      setFormData((prev) => ({
        ...prev,
        stripe_enable: paymentMap['stripe_enable'] || 0,
        paypal_enable: paymentMap['paypal_enable'] || 0,
        razorpay_enable: paymentMap['razorpay_enable'] || 0,
        iyzico_enable: paymentMap['iyzico_enable'] || 0,
        pesapal_enable: paymentMap['pesapal_enable'] || 0,
        payhere_enable: paymentMap['payhere_enable'] || 0,
        cashfree_enable: paymentMap['cashfree_enable'] || 0,
        applepay_enable: paymentMap['applepay_enable'] || 0,
        googlepay_enable: paymentMap['googlepay_enable'] || 0,
        ideabiz_enable: paymentMap['ideabiz_enable'] || 0,
      }))
      setDefaultOption(prev => ({
        ...prev,
        ...defaultoptionslist
      }))
    } catch (error) {
      console.error(error);
    }
  };

  const previewSubscriptionPlan = async () => {
    try {
      const response = await axios.get(`${previewApi}`, { headers: headers });
      const result = response?.data;

      // Parse devices_access_control from JSON string to object
      let parsedAccessControl = null;
      if (result?.plans?.devices_access_control) {
        try {
          parsedAccessControl = typeof result.plans.devices_access_control === 'string'
            ? JSON.parse(result.plans.devices_access_control)
            : result.plans.devices_access_control;
          console.log('Parsed devices_access_control:', parsedAccessControl);
        } catch (e) {
          console.error('Error parsing devices_access_control:', e);
        }
      }

      // Build individual device permission fields for the form
      const devicePermissions = {};
      if (parsedAccessControl) {
        Object.keys(parsedAccessControl).forEach(deviceId => {
          devicePermissions[`device_access_${deviceId}`] = parsedAccessControl[deviceId];
        });
      }

      // Parse restriction_source_types_days from JSON string
      let parsedRestrictions = null;
      let restrictionSourceTypesDays = {};
      let selectedSourceTypes = [];
      let commonDays = '';

      if (result?.plans?.restriction_source_types_days) {
        try {
          parsedRestrictions = typeof result.plans.restriction_source_types_days === 'string'
            ? JSON.parse(result.plans.restriction_source_types_days)
            : result.plans.restriction_source_types_days;

          // Convert parsed restrictions to form structure and extract common days
          Object.keys(parsedRestrictions).forEach(sourceTypeId => {
            restrictionSourceTypesDays[sourceTypeId] = parsedRestrictions[sourceTypeId] || '';

            // Get common days from first source type (since all should have same value)
            if (!commonDays) {
              commonDays = parsedRestrictions[sourceTypeId] || '';
            }
          });

          console.log('Parsed restriction_source_types_days:', parsedRestrictions);
        } catch (e) {
          console.error('Error parsing restriction_source_types_days:', e);
        }
      }

      // Parse secondary_prices from JSON string
      let parsedSecondaryPrices = {};
      if (result?.plans?.secondary_prices) {
        try {
          parsedSecondaryPrices = typeof result.plans.secondary_prices === 'string'
            ? JSON.parse(result.plans.secondary_prices)
            : result.plans.secondary_prices;
          console.log('Parsed secondary_prices:', parsedSecondaryPrices);
        } catch (e) {
          console.error('Error parsing secondary_prices:', e);
        }
      }

      setFormData((prev) => ({
        ...prev,
        ...result?.plans,
        ...result?.Devices,
        ...devicePermissions,
        devices_access_control: parsedAccessControl, // Store parsed object
        restriction_source_types_days: restrictionSourceTypesDays,
        selected_source_types: selectedSourceTypes,
        common_days: commonDays,
        secondary_prices: parsedSecondaryPrices,
        SubscriptionPlan_Name: result?.SubscriptionPlan_Name,
        coupon_gateways: (() => {
          try {
            const raw = result?.plans?.coupon_gateways;
            return Array.isArray(raw) ? raw : (raw ? JSON.parse(raw) : []);
          } catch (_) { return []; }
        })(),
      }))

      // ── Load plan-based-video contents if feature is enabled ──────────────
      if (result?.plans?.plan_based_video == 1 && result?.plans?.id) {
        try {
          const contentsRes = await axios.get(
            `${baseURL}/admin/subscription/${result.plans.id}/plan-contents`,
            { headers }
          );
          const existingContents = contentsRes?.data?.data || [];
          setFormData(prev => ({
            ...prev,
            plan_contents: existingContents.map(c => ({
              source_id: c.source_id,
              source_type: c.source_type,
              title: c.title,
            })),
          }));
          // Tick the filter chips for every content type that is actually selected
          const uniqueTypes = [...new Set(existingContents.map(c => Number(c.source_type)))];
          if (uniqueTypes.length > 0) setPbvSelectedTypes(uniqueTypes);
        } catch (e) {
          console.warn('Failed to load plan contents:', e.message);
        }
      }
      // ── End plan contents load ────────────────────────────────────────────

    } catch (error) {
      console.error(error);
    }
  };

  const deviceIds = formData?.devices
    ?.split(",")
    ?.filter(id => id)
    ?.map(id => parseInt(id));


  const deviceObjects = Object.values(formData).filter(
    item => typeof item === "object" && item?.devices_name
  );

  const handleAdd = async () => {
    const findApi = !id ? addApi : ``;
    setShowOverlay(true);
    alert("⚠️ Price, Billing Interval, and Trial Days cannot be changed once a plan has active subscriptions.To change them, create a new plan.")
    try {
      const formDataAdd = {};

      // Iterate over the keys in formData and include relevant ones
      for (const key in formData) {
        if (["plans_name", "billing_interval", "billing_type", "plan_content", "ads_status", "plan_trail_status", "status", "price", "days", "plan_trail_days", "ios_product_id", "ios_plan_price", "google_pay_product_id", "google_pay_plan_price", "payment_type", "devices", "iyzico_enable", "razorpay_enable", "paypal_enable", "stripe_enable", "pesapal_enable", "payhere_enable", "cashfree_enable", "applepay_enable", "googlepay_enable", "ideabiz_enable", "ideabiz_plan_id", "plan_category", "currency", "premium_content", "music", "live_tv", "max_audio_quality", "device_limit", "plan_based_video"].includes(key)) {
          formDataAdd[key] = formData[key];
        }
      }
      // Send coupon_gateways as JSON string
      formDataAdd['coupon_gateways'] = JSON.stringify(
        Array.isArray(formData.coupon_gateways) ? formData.coupon_gateways : []
      );
      // Include plan contents if plan_based_video is enabled
      if (Number(formData.plan_based_video) === 1 && formData.plan_contents?.length > 0) {
        formDataAdd['plan_contents'] = formData.plan_contents;
      }

      // Include secondary_prices if secondary currencies are enabled
      if (defaultOption?.enable_secondary_currency == 1 && formData?.secondary_prices && Object.keys(formData.secondary_prices).length > 0) {
        formDataAdd['secondary_prices'] = JSON.stringify(formData.secondary_prices);
      }

      const selectedPlatforms = formData?.individual_platoforms_combination?.map(item => item.value || [])
      const deviceCombinationCount = { devices: selectedPlatforms, count: Number(formData?.devices_count) }
      formDataAdd['devices_count'] = formData?.devices === 'total_limit' ? Number(formData?.devices_count) : formData?.devices === 'individual_limit' ? JSON.stringify(formData.individual_limits) : JSON.stringify(deviceCombinationCount)

      // Collect video quality (if applicable)
      formDataAdd['video_quality'] = formData?.video_quality?.map((option) => option?.value).join();

      // Build access JSON from device_access fields (for ALL devices, not just selected ones)
      const accessObj = {};

      // Loop through ALL devices from defaultOption (not just formData.devices)
      defaultOption?.devicesOption?.forEach(device => {
        const deviceId = device.id.toString();
        const permissions = formData[`device_access_${deviceId}`];

        if (permissions && permissions.length > 0) {
          accessObj[deviceId] = permissions;
        }
      });

      formDataAdd['devices_access_control'] = Object.keys(accessObj).length > 0 ? accessObj : null;

      const restrictionObj = {};

      // Process all selected source types with common days value
      formData.selected_source_types?.forEach(sourceType => {
        const sourceTypeId = sourceType.value.toString();
        const commonDays = formData.common_days || '';
        console.log(`DEBUG: Processing selected sourceTypeId ${sourceTypeId} with common days '${commonDays}'`);
        restrictionObj[sourceTypeId] = commonDays;
      });

      formDataAdd['restriction_source_types_days'] = Object.keys(restrictionObj).length > 0 ? restrictionObj : null;

      // Send POST request to API
      const response = await axios({
        method: "POST",
        url: findApi,
        data: formDataAdd,
        headers: headers,
      });

      const result = response?.data;
      if (result?.status) {
        // save custom field values (strict)
        try {
          const entityId = result?.id || result?.plan_id || result?.group_plan_id || result?.Group_plan_id;
        } catch (e) {
          toast.error(e?.message || 'Failed to save additional fields');
          setShowOverlay(false);
          return;
        }
        setShowOverlay(false);
        toast.success(result?.message);
        if (!id) {
          navigate("/subscription-plans");
        } else {
          // setWithOutRefresh(!withOutRefresh);
        }
      } else {
        setShowOverlay(false);
        toast.error(result?.message);
      }
    } catch (err) {
      setShowOverlay(false);
      const errorMessage = err?.response?.data?.message;
      toast.error(errorMessage);
      console.error("error", err);
    }
  };


  const handleStore = (e) => {
    e.preventDefault()
    if (formValidation()) {
      handleAdd()
    }
  }

  useEffect(async () => {
    await labelFetch()
    await FetchCurrency()
    await fetchCreate()
  }, []);

  useEffect(async () => {
    await previewSubscriptionPlan()
  }, [withOutRefresh])

  // Build selected source types after both defaultOption and formData are populated
  useEffect(() => {
    if (id && defaultOption?.sourceTypesOption?.length > 0 && formData?.restriction_source_types_days && Object.keys(formData.restriction_source_types_days).length > 0) {
      const selectedSourceTypes = [];
      Object.keys(formData.restriction_source_types_days).forEach(sourceTypeId => {
        const sourceType = defaultOption.sourceTypesOption.find(st => st.value == sourceTypeId);
        if (sourceType) {
          selectedSourceTypes.push(sourceType);
        }
      });

      if (selectedSourceTypes.length > 0 && JSON.stringify(selectedSourceTypes) !== JSON.stringify(formData.selected_source_types)) {
        setFormData(prev => ({
          ...prev,
          selected_source_types: selectedSourceTypes
        }));
      }
    }
  }, [id, defaultOption.sourceTypesOption, formData.restriction_source_types_days])

  // Sync currency symbol when currency code or options change
  useEffect(() => {
    if (formData?.currency && defaultOption?.currencyOption?.length > 0) {
      const selected = defaultOption.currencyOption.find(item => item.code === formData.currency);
      if (selected && selected.symbol !== symbol) {
        setSymbol(selected.symbol);
      }
    }
  }, [formData?.currency, defaultOption?.currencyOption]);



  const handleUpdate = async () => {

    if (formValidation()) {
      const formDataAdd = {};
      for (const key in formData) {
        if (["plans_name", "group_plan_id", "devices", "ads_status", "status", "plan_content", "plan_trail_status", "plan_trail_days", "currency", "premium_content", "music", "live_tv", "max_audio_quality", "device_limit", "plan_category", "plan_based_video"].includes(key)) {
          formDataAdd[key] = formData[key];
        }
      }
      // Send coupon_gateways as JSON string
      formDataAdd['coupon_gateways'] = JSON.stringify(
        Array.isArray(formData.coupon_gateways) ? formData.coupon_gateways : []
      );
      // Include plan contents (always send so backend can clear when disabled)
      formDataAdd['plan_contents'] = Number(formData.plan_based_video) === 1 ? (formData.plan_contents || []) : [];
      const selectedPlatforms = formData?.individual_platoforms_combination?.map(item => item.value || [])
      const deviceCombinationCount = { devices: selectedPlatforms, count: Number(formData?.devices_count) }
      formDataAdd['devices_count'] = formData?.devices === 'total_limit' ? Number(formData?.devices_count) : formData?.devices === 'individual_limit' ? JSON.stringify(formData.individual_limits) : JSON.stringify(deviceCombinationCount)

      // Handle video quality properly for both array and string formats
      formDataAdd["video_quality"] = Array.isArray(formData?.video_quality)
        ? formData?.video_quality?.map((item => item?.value)).join(",")
        : formData?.video_quality

      // Ensure devices_count is properly formatted
      if (formDataAdd.devices_count && typeof formDataAdd.devices_count !== 'string') {
        formDataAdd.devices_count = String(formDataAdd.devices_count);
      }

      // Ensure plan_trail_days is properly handled
      if (formData?.plan_trail_status == 1 && formData?.plan_trail_days) {
        formDataAdd.plan_trail_days = formData.plan_trail_days;
      } else if (formData?.plan_trail_status == 0) {
        formDataAdd.plan_trail_days = null;
      }

      // Build devices_access_control from individual device permission fields
      const accessObj = {};
      defaultOption?.devicesOption?.forEach(device => {
        const deviceId = device.id.toString();
        // Check if permissions are stored in formData.devices_access_control (from DB)
        let permissions;
        if (formData.devices_access_control && typeof formData.devices_access_control === 'object') {
          permissions = formData.devices_access_control[deviceId];
        }
        if (permissions && permissions.length > 0) {
          accessObj[deviceId] = permissions;
        }
      });
      formDataAdd['devices_access_control'] = Object.keys(accessObj).length > 0 ? accessObj : null;

      // Handle restriction_source_types_days for update - use common days for all selected source types
      const restrictionObj = {};

      // Process all selected source types with common days value
      formData.selected_source_types?.forEach(sourceType => {
        const sourceTypeId = sourceType.value.toString();
        const commonDays = formData.common_days || '';
        restrictionObj[sourceTypeId] = commonDays;
      });

      formDataAdd['restriction_source_types_days'] = Object.keys(restrictionObj).length > 0 ? restrictionObj : null;

      await fetchRequest({
        method: 'POST',
        url: `${updateApi}`,
        params: {},
        data: formDataAdd,
      }).then(async (res) => {
        // save custom field values (strict)
        try {
        } catch (e) {
          toast.error(e?.message || 'Failed to save additional fields');
          return;
        }
        toast.success(res?.message)
        setWithOutRefresh((prev) => !prev)
      }).catch((err) => {
        toast.error(err.response?.data?.message || err?.message);
      })
    }
    else {
      // toast.error("validation error")
    }
  };

  return (
    <>

      <AdminBackNavigation path={`${'/subscription-plans'}`} text="Back" />
      {showOverlay && (<Response_Processing />)}
      {!id ?
        <>
          <AdminSaveHeader heading={labelDisplay?.[2]?.title} saveText={labelDisplay?.[1]?.title} saveMethod={handleStore} />
          <div className="d-flex align-items-center flex-wrap mb-3">
            {defaultOption?.paymentOption?.map((item) => {
              // console.log("Payment    item:", item); // Debug log
              if (item?.payment_type) {
                return (
                  <div className="col-12 col-md-6 col-lg-4 pe-3 mb-3" key={item.payment_type}>
                    <div className=" d-flex align-items-center justify-content-between  p-3 theme-bg-color rounded-3">
                      <div className="d-flex flex-wrap flex-column">
                        <MessageLabel text={item?.type == 'cashfree_enable' ? 'Cashfree' : item.payment_type} className={"mb-0 mb-md-0"} />
                        <MessageBox classname={`${item?.payment_mode == 0 ? "text-color-button" : "text-color-button"} fw-bold mt-1`} text={item?.payment_mode == 0 ? "Test mode" : "Live mode"} />
                      </div>
                      <AdminCheckBox name={item?.type} checked={formData?.[item?.type] == 1} onChange={handleInput} />
                      {/* <MessageLabel text={item?.payment_mode == 0 ? "TEST" : "LIVE"} className={`mb-0 mb-md-0  px-3 rounded-5 ${item?.payment_mode == 1 ? "button-bg-color theme-body-text-color" : "theme-border-secondary"} `} /> */}
                    </div>
                  </div>
                );
              }
              return null;
            })}
          </div>
          <FormContainer>
            <LeftWrapper>
              <Wrapper>
                <MessageHeading text={labelDisplay?.[3]?.title} />
                <MessageLabel text={labelDisplay?.[4]?.title} className="mandatorySimple" />
                <AdminCustomInput type="text" name="plans_name" value={formData?.plans_name} onChange={handleInput} placeHolder={"Plan Name"} ref={(el) => (combinedRef.current.plans_name = el)} error={formDataError?.plans_name} />
                <MessageLabel text={labelDisplay?.[5]?.title} className="mandatorySimple" />
                <AdminCustomSelect name="billing_interval" value={formData?.billing_interval} onChange={handleInput} ref={(el) => (combinedRef.current.billing_interval = el)} options={defaultOption?.intervalOption?.map((item, index) => ({ name: item?.name, value: item?.value }))} error={formDataError?.billing_interval} defaultOptionName={"Choose an Interval"} />
                <MessageLabel text={labelDisplay?.[6]?.title} className="mandatorySimple" />
                <AdminCustomInput type="text" name="billing_type" value={formData?.billing_type} onChange={handleInput} placeHolder={"Billing Type"} ref={(el) => (combinedRef.current.billing_type = el)} error={formDataError?.billing_type} />
                <MessageLabel text={labelDisplay?.[7]?.title} />
                <JoditEditor className="mb-3" ref={(el) => (combinedRef.current.plan_content = el)} value={formData?.plan_content} onChange={(newContent) => setFormData(prev => ({ ...prev, plan_content: newContent }))} />
                {formDataError?.plan_content && (<div className='d-flex align-items-center gap-1 mb-2'><IoMdInformationCircle className='errorred' style={{ width: "17px", height: "16px" }} /><MessageBox text={`${formDataError?.plan_content}`} classname='errorred  d-block' /></div>)}

                <MessageLabel text={labelDisplay?.[15]?.title} className="mandatorySimple" />
                <Select options={defaultOption?.resolutionOption} isMulti name={'video_quality'} onChange={handleMultiSelect} value={formData?.video_quality} ref={(el) => (combinedRef.current.video_quality = el)} className={`${formDataError?.video_quality && 'custom-input-error'} custom-select-multi custom-placeholder theme-text-color mb-3`} />
                {formDataError?.video_quality && (<MessageBox text={`${formDataError?.video_quality}`} classname='errorred mb-2 d-block' />)}

                {/* <div className="card p-3 mt-3">
                  <MessageHeading text="Additional Fields" />
                  {/* Custom fields removed */}
                {/* </div> */}

              </Wrapper>


              {/* Device Access Permissions Section (Show for All Devices) */}
              <Wrapper>
                <MessageHeading text="Device Access Permissions" />

                {defaultOption?.devicesOption?.map((device) => {
                  const currentAccess = formData[`device_access_${device?.id}`] || [];

                  const accessOptions = [
                    { value: 'screen_cast', label: 'screen cast' },
                    { value: 'download', label: 'download' }
                  ];

                  const selectedAccessValues = currentAccess
                    .map(val => accessOptions.find(opt => opt.value === val))
                    .filter(Boolean);

                  return (
                    <div key={`access_${device?.id}`} className="mb-3">
                      <MessageLabel text={device?.devices_name} />
                      <Select
                        options={accessOptions}
                        isMulti
                        name={`device_access_${device?.id}`}
                        value={selectedAccessValues}
                        onChange={(selectedOptions) => {
                          const values = selectedOptions ? selectedOptions.map(opt => opt.value) : [];
                          setFormData(prev => ({
                            ...prev,
                            [`device_access_${device?.id}`]: values
                          }));
                        }}
                        className="custom-select-multi custom-placeholder theme-text-color mb-2"
                        placeholder="Select Permissions"
                      />
                    </div>
                  );
                })}
              </Wrapper>

              {/* <Wrapper>
                <MessageHeading text="Manage Plan Content" crown />
                <div className="d-flex justify-content-between mb-2 ">
                  <div className="col-6 col-md-6 pe-2">
                    <MessageLabel text="Premium Content Enable" />
                  </div>
                  <div className="col-6 col-md-6 ps-2 text-end">
                    <AdminSwitch name={'premium_content'} checked={formData?.premium_content == 1} onChange={handleInput} />
                  </div>
                </div>

                <div className="d-flex justify-content-between mb-2 ">
                  <div className="col-6 col-md-6 pe-2">
                    <MessageLabel text="Music Enable" />
                  </div>
                  <div className="col-6 col-md-6 ps-2 text-end">
                    <AdminSwitch name={'music'} checked={formData?.music == 1} onChange={handleInput} />
                  </div>
                </div>

                <div className="d-flex justify-content-between mb-2 ">
                  <div className="col-6 col-md-6 pe-2">
                    <MessageLabel text="Live TV Enable" />
                  </div>
                  <div className="col-6 col-md-6 ps-2 text-end">
                    <AdminSwitch name={'live_tv'} checked={formData?.live_tv == 1} onChange={handleInput} />
                  </div>
                </div>

                <div className="mb-2">
                  <MessageLabel text="Max Audio Quality" />
                  <AdminCustomInput type="text" name="max_audio_quality" value={formData?.max_audio_quality} onChange={handleInput} placeHolder="Enter audio quality (e.g. Stereo, Dolby)" />
                </div>

              </Wrapper> */}

              {/* ── Plan Based Video ─────────────────────────────────────── */}
              <Wrapper>
                <div className="d-flex justify-content-between mb-2">
                  <div className="col-8 pe-2">
                    <MessageHeading text="Plan Based Video" noMargin />
                    <p className="theme-text-color opacity-50 small mt-1 mb-0" style={{ fontStyle: 'italic' }}>
                      Restrict this plan to only hand-picked content
                    </p>
                  </div>
                  <div className="col-4 ps-2 text-end">
                    <AdminSwitch name="plan_based_video" checked={formData?.plan_based_video == 1} onChange={handleInput} />
                  </div>
                </div>

                {formData?.plan_based_video == 1 && (
                  <div className="mt-3">
                    {/* Content type filter chips */}
                    <MessageLabel text="Filter by content type" className="mb-2" />
                    <div className="d-flex flex-wrap gap-2 mb-3">
                      {CONTENT_TYPE_OPTIONS.map(opt => {
                        const isSelected = pbvSelectedTypes.includes(opt.value);
                        return (
                          <button key={opt.value} type="button"
                            className={`btn btn-sm rounded-pill d-flex align-items-center gap-1 ${isSelected ? 'button-bg-color theme-body-text-color' : 'btn-outline-secondary'}`}
                            onClick={() => handlePbvTypeToggle(opt.value)}>
                            {isSelected && <MdCheck style={{ width: '14px', height: '14px' }} />}
                            {opt.label}
                          </button>
                        );
                      })}
                    </div>

                    {/* Search box */}
                    <MessageLabel text="Search content to add" className="mb-1" />
                    <AdminCustomInput type="text" name="pbv_search" value={pbvSearchQuery} onChange={handlePbvQueryChange} placeHolder="Type to search..." />

                    {/* Search results */}
                    {pbvSearchLoading && <p className="theme-text-color opacity-50 small mt-1">Searching…</p>}
                    {!pbvSearchLoading && pbvSearchResults.length > 0 && (
                      <div className="mt-2 rounded-3 overflow-hidden" style={{ border: '1px solid var(--border-color, #e2e8f0)', maxHeight: '200px', overflowY: 'auto' }}>
                        {pbvSearchResults.map(item => {
                          const isAdded = formData.plan_contents?.some(
                            c => c.source_id === item.id && c.source_type === item.source_type
                          );
                          return (
                            <div key={`${item.source_type}-${item.id}`}
                              className="d-flex align-items-center justify-content-between px-3 py-2"
                              style={{ borderBottom: '1px solid var(--border-color, #e2e8f0)', cursor: 'pointer' }}
                              onClick={() => handleAddPbvContent(item)}>
                              <div className="d-flex align-items-center">
                                <span className="theme-text-color small">{item.title}</span>
                                <span className="theme-text-color small opacity-50 ms-1">— {sourceTypeLabel(item.source_type)}</span>
                              </div>
                              {isAdded && (
                                <MdCheck style={{ width: '16px', height: '16px', flexShrink: 0, color: 'var(--button-color)' }} />
                              )}
                            </div>
                          );
                        })}
                      </div>
                    )}

                    {/* Selected content chips */}
                    {formData.plan_contents?.length > 0 && (
                      <div className="mt-3">
                        <MessageLabel text={`Selected content (${formData.plan_contents.length})`} className="mb-2" />
                        <div className="d-flex flex-wrap gap-2">
                          {formData.plan_contents.map(item => (
                            <span key={`${item.source_type}-${item.source_id}`}
                              className="badge d-flex align-items-center gap-1 rounded-pill px-3 py-2"
                              style={{ background: 'var(--button-color)', color: 'var(--body-text-color)', fontSize: '12px' }}>
                              <span>{item.title}</span>
                              <small className="opacity-75">({sourceTypeLabel(item.source_type)})</small>
                              <MdOutlineRemoveCircle style={{ cursor: 'pointer', width: '14px', height: '14px' }}
                                onClick={() => handleRemovePbvContent(item.source_id, item.source_type)} />
                            </span>
                          ))}
                        </div>
                      </div>
                    )}
                  </div>
                )}
              </Wrapper>
              {/* ── End Plan Based Video ──────────────────────────────────── */}

            </LeftWrapper>
            <RightWrapper>
              {/* Plan Category  */}
              <Wrapper>
                <MessageHeading text="Plan Subscription Category" />
                <MessageLabel text={`Plan Category`} className="mandatorySimple" />
                <AdminCustomSelect name="plan_category" value={formData?.plan_category} onChange={handleInput} ref={(el) =>
                  (combinedRef.current.plan_category = el)} options={categoryOptions?.map((item, index) => ({
                    name:
                      item?.name, value: item?.value
                  }))} error={formDataError?.plan_category}
                />
              </Wrapper>

              <Wrapper>
                <MessageHeading text={labelDisplay?.[11]?.title} />
                <div className="d-flex justify-content-between align-items-center">
                  <MessageLabel text="Currency" className="" />
                  <Link to="/currency_settings" className="theme-text-color text-decoration-underline small mb-2 d-flex align-items-center">
                    Manage Currency <CiShare1 style={{ width: "15px", height: "15px", strokeWidth: '1px', marginLeft: "6px" }} />
                  </Link>
                </div>
                <AdminCustomSelect
                  name="currency"
                  value={formData?.currency}
                  onChange={handleInput}
                  options={defaultOption?.currencyOption?.map((item) => ({
                    name: `${item?.country} (${item?.code})`,
                    value: item?.code
                  }))}
                  error={formDataError?.currency}
                  defaultOptionName={"Choose a Currency"}
                />
                <MessageLabel text={`${labelDisplay?.[12]?.title} (${symbol})`} className="mandatorySimple" />
                <AdminCustomInput type="number" name="price" value={formData?.price} onChange={handleInput} placeHolder="Price" min={1} maxLength={9} ref={(el) => (combinedRef.current.price = el)} error={formDataError?.price} restrictNumberInput />

                {/* Multi-Currency Prices — shown when Enable Secondary Countries is ON */}
                {defaultOption?.enable_secondary_currency == 1 && defaultOption?.secondary_currencies?.length > 0 && (
                  <div className="mt-3" style={{ borderTop: '1px solid var(--border-color, #e2e8f0)', paddingTop: '16px' }}>
                    <div className="d-flex align-items-center gap-2 mb-1">
                      <BsCurrencyExchange style={{ width: '16px', height: '16px', opacity: 0.7 }} className="theme-text-color" />
                      <span className="fw-semibold theme-text-color" style={{ fontSize: '13px' }}>Multi-Currency Pricing</span>
                      <span className="badge rounded-pill ms-1 button-bg-color theme-body-text-color" style={{ fontSize: '10px', padding: '2px 8px' }}>
                        {defaultOption.secondary_currencies.length} {defaultOption.secondary_currencies.length === 1 ? 'currency' : 'currencies'}
                      </span>
                    </div>
                    <p className="mb-3" style={{ fontSize: '12px', opacity: 0.6 }} >
                      Set a specific price for each secondary currency. Leave blank to inherit the primary price.
                    </p>

                    <div className="rounded-3 overflow-hidden" style={{ border: '1px solid var(--border-color, #e2e8f0)' }}>
                      {defaultOption.secondary_currencies.map((code, index) => {
                        const currObj = defaultOption?.currencyOption?.find((c) => c.code === code);
                        const priceData = formData?.secondary_prices?.[code];
                        const priceValue = typeof priceData === 'object' ? priceData?.amount : priceData;
                        const hasValue = priceValue !== '' && priceValue !== undefined;
                        return (
                          <div
                            key={code}
                            style={{
                              borderBottom: index < defaultOption.secondary_currencies.length - 1
                                ? '1px solid var(--border-color, #e2e8f0)'
                                : 'none',
                              padding: '12px 14px',
                              background: hasValue ? 'rgba(37,99,235,0.03)' : 'transparent',
                              transition: 'background 0.2s'
                            }}
                          >
                            <div className="d-flex align-items-center justify-content-between mb-1">
                              <div className="d-flex align-items-center gap-2">
                                <span
                                  className="fw-bold button-bg-color theme-body-text-color"
                                  style={{
                                    fontSize: '13px',
                                    borderRadius: '5px',
                                    padding: '2px 8px',
                                    minWidth: '46px',
                                    textAlign: 'center',
                                    letterSpacing: '0.5px'
                                  }}
                                >
                                  {code}
                                </span>
                                {currObj?.country && (
                                  <span style={{ fontSize: '12px', opacity: 0.55 }}>{currObj.country}</span>
                                )}
                              </div>
                              {hasValue && (
                                <button
                                  type="button"
                                  title="Clear price"
                                  onClick={() => handleSecondaryPriceChange(code, '')}
                                  style={{ background: 'none', border: 'none', cursor: 'pointer', padding: '0', display: 'flex', alignItems: 'center', opacity: 0.5 }}
                                >
                                  <MdOutlineRemoveCircle style={{ width: '16px', height: '16px', color: '#ef4444' }} />
                                </button>
                              )}
                            </div>

                            {/* Input row with common component */}
                            <div className="d-flex align-items-center gap-3">
                              <div className="flex-grow-1">
                                <AdminCustomInput
                                  type="number"
                                  name={`secondary_price_${code}`}
                                  value={typeof formData?.secondary_prices?.[code] === 'object' ? formData.secondary_prices[code]?.amount : (formData?.secondary_prices?.[code] ?? '')}
                                  onChange={(e) => handleSecondaryPriceChange(code, e.target.value)}
                                  placeHolder={`0.00`}
                                  min={0}
                                  className="mb-0"
                                  noMargin={true}
                                  appendText={code}
                                />
                              </div>
                            </div>
                          </div>
                        );
                      })}
                    </div>
                  </div>
                )}
                {/* <MessageLabel text={labelDisplay?.[14]?.title} className="mandatorySimple" />
                <AdminCustomInput type="number" name="days" value={formData?.days} onChange={handleInput} placeHolder={"Days"} ref={(el) => (combinedRef.current.days = el)} error={formDataError?.days} /> */}

                {/* <MessageLabel text={labelDisplay?.[17]?.title} className="mandatorySimple" />
                <Select options={defaultOption?.resolutionOption} isMulti name={'resolution'} onChange={handleMultiSelect} value={formData?.resolution} className="custom-select-multi custom-placeholder theme-text-color mb-3" /> */}
              </Wrapper>

              {/* Apple Pay Section - Show only if applepay_payment_settings.status == 1 */}
              {defaultOption?.paymentOption?.find(p => p.type === 'applepay_enable')?.status == 1 && (
                <Wrapper>
                  <MessageHeading text="Apple Pay" />
                  <MessageLabel text={labelDisplay?.[17]?.title} className="" />
                  <AdminCustomInput type="text" name="ios_product_id" value={formData?.ios_product_id} onChange={handleInput} placeHolder={"IOS Product ID"} ref={(el) => (combinedRef.current.ios_product_id = el)} error={formDataError?.ios_product_id} />
                  <MessageLabel text={`${labelDisplay?.[18]?.title} ${symbol}`} className="" />
                  <AdminCustomInput type="number" name="ios_plan_price" value={formData?.ios_plan_price} onChange={handleInput} placeHolder="IOS Plan Price" min={1} maxLength={9} ref={(el) => (combinedRef.current.ios_plan_price = el)} error={formDataError?.ios_plan_price} restrictNumberInput />
                </Wrapper>
              )}

              {/* Google Pay Section - Show only if googlepay_payment_settings.status == 1 */}
              {defaultOption?.paymentOption?.find(p => p.type === 'googlepay_enable')?.status == 1 && (
                <Wrapper>
                  <MessageHeading text="Google Pay" />
                  <MessageLabel text="Google Pay Product ID" className="" />
                  <AdminCustomInput type="text" name="google_pay_product_id" value={formData?.google_pay_product_id} onChange={handleInput} placeHolder={"Google Pay Product ID"} ref={(el) => (combinedRef.current.google_pay_product_id = el)} error={formDataError?.google_pay_product_id} />
                  <MessageLabel text={`Google Pay Plan Price (${symbol})`} className="" />
                  <AdminCustomInput type="number" name="google_pay_plan_price" value={formData?.google_pay_plan_price} onChange={handleInput} placeHolder="Google Pay Plan Price" min={1} maxLength={9} ref={(el) => (combinedRef.current.google_pay_plan_price = el)} error={formDataError?.google_pay_plan_price} restrictNumberInput />
                </Wrapper>
              )}

              {/* Ideabiz Section - Show only if ideabiz_payment_settings.status == 1 */}
              {defaultOption?.paymentOption?.find(p => p.type === 'ideabiz_enable')?.status == 1 && (
                <Wrapper>
                  <MessageHeading text="Ideabiz" />
                  <MessageLabel text="Ideabiz Plan ID" className="" />
                  <AdminCustomInput type="text" name="ideabiz_plan_id" value={formData?.ideabiz_plan_id} onChange={handleInput} placeHolder={"Ideabiz Plan ID"} ref={(el) => (combinedRef.current.ideabiz_plan_id = el)} error={formDataError?.ideabiz_plan_id} />
                </Wrapper>
              )}

              <Wrapper>
                <MessageHeading text={labelDisplay?.[19]?.title} />
                <MessageSubHeading text={labelDisplay?.[20]?.title} />

                <p className="theme-text-color opacity-50 small mt-1 mb-1" style={{ fontStyle: 'italic' }}>
                  (One-time - Only for Stripe & Razorpay payment gateways)
                </p>

                <div className='d-flex align-items-center justify-content-start gap-4'>

                  <div className='d-flex align-items-center gap-2'>
                    <AdminCustomRadio name="payment_type" id="payment_type_recurring" value="recurring" className={"mb-3"} checked={formData?.payment_type == "recurring"} onChange={handleInput} />
                    <MessageLabel text={labelDisplay?.[21]?.title || "Recurring"} />
                  </div>

                  <div className='d-flex align-items-center gap-2'>
                    <AdminCustomRadio name="payment_type" id="payment_type_one_time" value="one_time" className={"mb-3"} checked={formData?.payment_type == "one_time"} onChange={handleInput} />
                    <MessageLabel text={"One-Time"} />
                  </div>
                </div>

              </Wrapper>

              {(formData?.stripe_enable == 1 || formData?.razorpay_enable == 1) && formData?.payment_type !== 'one_time' && (
                <Wrapper>
                  <div className="mb-3">
                    <MessageHeading text="Plan Trial Settings" noMargin />
                    <p className="theme-text-color opacity-50 small mt-1 mb-0" style={{ fontStyle: 'italic' }}>
                      (Only for Stripe & Razorpay payment gateways)
                    </p>
                  </div>
                  <div className="d-flex justify-content-between mb-2 ">
                    <div className="col-6 col-md-6 pe-2">
                      <MessageLabel text={labelDisplay?.[10]?.title} />
                    </div>
                    <div className="col-6 col-md-6 ps-2 text-end">
                      <AdminSwitch name={'plan_trail_status'} checked={formData?.plan_trail_status == 1} onChange={handleInput} />
                    </div>
                  </div>

                  {formData?.plan_trail_status == 1 && (<>
                    <MessageLabel text={labelDisplay?.[14]?.title} className="mandatorySimple" />
                    <AdminCustomInput min={0} type="number" name="plan_trail_days" value={formData?.plan_trail_days} onChange={handleInput} placeHolder={"Plan Trail Days"} ref={(el) => (combinedRef.current.plan_trail_days = el)} error={formDataError?.plan_trail_days} />
                  </>)}
                </Wrapper>
              )}

              {(formData?.stripe_enable == 1 || formData?.razorpay_enable == 1) && (
                <Wrapper>
                  <MessageHeading text="Coupon Settings" />
                  <MessageSubHeading text="Select which payment gateways allow coupon / promo codes on this plan." />
                  <div className="d-flex flex-column gap-2 mt-2">
                    {formData?.stripe_enable == 1 && (
                      <label className="d-flex align-items-center gap-2" style={{ cursor: 'pointer' }}>
                        <input
                          type="checkbox"
                          checked={Array.isArray(formData?.coupon_gateways) && formData.coupon_gateways.includes(1)}
                          onChange={() => handleCouponGatewayToggle(1)}
                          style={{ width: '18px', height: '18px', cursor: 'pointer', accentColor: '#63CAB7' }}
                        />
                        <img src={stripe_image} alt="Stripe" style={{ height: '20px', objectFit: 'contain' }} />
                        <MessageLabel text="Stripe" className="mb-0" />
                      </label>
                    )}
                    {formData?.razorpay_enable == 1 && (
                      <label className="d-flex align-items-center gap-2" style={{ cursor: 'pointer' }}>
                        <input
                          type="checkbox"
                          checked={Array.isArray(formData?.coupon_gateways) && formData.coupon_gateways.includes(2)}
                          onChange={() => handleCouponGatewayToggle(2)}
                          style={{ width: '18px', height: '18px', cursor: 'pointer', accentColor: '#63CAB7' }}
                        />
                        <img src={razorpay_image} alt="Razorpay" style={{ height: '20px', objectFit: 'contain' }} />
                        <MessageLabel text="Razorpay" className="mb-0" />
                      </label>
                    )}
                  </div>
                </Wrapper>
              )}

              <Wrapper>
                <MessageHeading text={labelDisplay?.[8]?.title} />
                <div className="d-flex justify-content-between mb-2 ">
                  <div className="col-6 col-md-6 pe-2">
                    <MessageLabel text={labelDisplay?.[9]?.title} />
                  </div>
                  <div className="col-6 col-md-6 ps-2 text-end">
                    <AdminSwitch name={'ads_status'} checked={formData?.ads_status == 1} onChange={handleInput} />
                  </div>
                </div>

                <div className="d-flex justify-content-between mb-2 ">
                  <div className="col-6 col-md-6 pe-2">
                    <MessageLabel text="Active Status" />
                  </div>
                  <div className="col-6 col-md-6 ps-2 text-end">
                    <AdminSwitch name={'status'} checked={formData?.status == 1} onChange={handleInput} />
                  </div>
                </div>
              </Wrapper>



              {/* Source Types with Common Days Section */}
              <Wrapper>
                <MessageHeading text="Restriction Time Period (New Release)" />
                <MessageLabel text="Select Source Types" className="" />
                <Select
                  options={defaultOption?.sourceTypesOption}
                  isMulti
                  name="selected_source_types"
                  onChange={handleSourceTypeSelect}
                  value={formData?.selected_source_types || []}
                  className="custom-select-multi custom-placeholder theme-text-color mb-3"
                  placeholder="Select Source Types"
                />
                {formDataError?.selected_source_types && (
                  <MessageBox text={formDataError.selected_source_types} classname="errorred mb-2 d-block" />
                )}

                {/* Common days input for all selected source types */}
                {formData?.selected_source_types?.length > 0 && (
                  <div className="mb-3">
                    <MessageLabel text="Days (Applies to all selected source types)" className="" />
                    <AdminCustomInput
                      type="number"
                      name="common_days"
                      value={formData.common_days || ''}
                      onChange={(e) => handleCommonDaysChange(e.target.value)}
                      placeHolder="Enter number of days"
                      min={1}
                      error={formDataError.common_days}
                    />
                  </div>
                )}

                {/* Show selected source types */}
                {formData?.selected_source_types?.length > 0 && (
                  <div className="mb-3">
                    <MessageLabel text="Selected Source Types:" className="mb-2" />
                    <div className="d-flex flex-wrap gap-2">
                      {formData.selected_source_types.map((sourceType) => (
                        <span key={sourceType.value} className="badge bg-primary">
                          {sourceType.label}
                        </span>
                      ))}
                    </div>
                  </div>
                )}
              </Wrapper>

              <Wrapper>
                <MessageHeading text={labelDisplay?.[22]?.title} className="" />
                <MessageLabel text={"Select Device restrict type"} />
                <AdminCustomSelect name='devices' value={formData?.devices} options={formData?.defaultDeviceLimitOptions} onChange={handleInput} defaultOptionName={'Select Device Restriction Option'} />
                {formData?.devices === "total_limit" ?
                  <AdminCustomInput name="devices_count" min={1} max={99} type="number" value={formData?.devices_count} onChange={handleInput} placeHolder="Enter the device count" />
                  : formData?.devices === "platform_device_combination" ?
                    <>
                      <Select
                        ref={(el) => (combinedRef.current.destination_rtmp = el)}
                        options={formData?.individualDevicesList}
                        isMulti
                        name="individual_platoforms_combination"
                        value={formData?.individualDevicesList?.map(item => formData?.individual_platoforms_combination?.find(val => val?.value === item?.value))}
                        onChange={handleMultiSelect}
                        className={`custom-select-multi custom-input-border custom-placeholder bg-transparent theme-text-color w-100 mb-3 p-3`}
                        placeholder="Select Devices"
                      />
                      <AdminCustomInput name="devices_count" min={1} max={99} type="number" value={formData?.devices_count} onChange={handleInput} placeHolder="Enter the device count" />

                    </>
                    : formData?.devices === "individual_limit" && (
                      <>
                        <MessageSubHeading className={'px-2'} text="Laptop/Desktop" />
                        <AdminCustomInput value={formData?.individual_limits?.web} name='web' min={1} max={99} type="number" placeHolder="Enter the Web count" onChange={handleDeviceLimitChange} />
                        <MessageSubHeading className={'px-2'} text="Mobile" />
                        <AdminCustomInput value={formData?.individual_limits?.mobile} name='mobile' min={1} max={99} type="number" placeHolder="Enter the Mobile count" onChange={handleDeviceLimitChange} />
                        <MessageSubHeading className={'px-2'} text="Tablet" />
                        <AdminCustomInput value={formData?.individual_limits?.tablet} name='tablet' min={1} max={99} type="number" placeHolder="Enter the Tablet count" onChange={handleDeviceLimitChange} />
                        <MessageSubHeading className={'px-2'} text="TV" />
                        <AdminCustomInput value={formData?.individual_limits?.tv} name='tv' min={1} max={99} type="number" placeHolder="Enter the TV count" onChange={handleDeviceLimitChange} />
                      </>
                    )}
              </Wrapper>

            </RightWrapper>
            <AdminCustomButton saveMethod={handleStore} type="submit" saveText={id ? "Update Plan" : "Create Plan"} className="ms-auto" loading={showOverlay} />
          </FormContainer>
        </>
        :
        <>
          <div className="d-flex align-items-center flex-wrap justify-content-between mb-4" >
            <div className="col-12 col-md-8">
              <MessageHeading className="admin-title text-md-start mb-0" text={"Preview & Edit Subscription Plan"} noMargin padding />
            </div>
            <div className="col-12 col-md-4 d-flex justify-content-end">
              <AdminCustomButton saveMethod={handleUpdate} saveText={"Update"} className="" />
            </div>
          </div>

          <Wrapper>
            <MessageHeading text="Preview Plan" />
            <div className="d-flex align-items-center flex-wrap justify-content-between">
              <div className="col-lg-5 col-md-5 col-sm-5 position-relative">
                <MessageLabel text="Plan Name" className={""} />
              </div>
              <div className="col-lg-1 col-md-1 col-sm-1 position-relative">
                <MessageLabel text=":" className={""} />
              </div>
              <div className="col-lg-6 col-md-6 col-sm-6 position-relative">
                <MessageSubHeading text={formData?.plans_name ? formData.plans_name : '-'} className={""} />
              </div>
              <div className="col-lg-5 col-md-5 col-sm-5 position-relative">
                <MessageLabel text="Billing Interval" className={""} />
              </div>
              <div className="col-lg-1 col-md-1 col-sm-1 position-relative">
                <MessageLabel text=":" className={""} />
              </div>
              <div className="col-lg-6 col-md-6 col-sm-6 position-relative">
                <MessageSubHeading text={formData?.billing_interval ? formData.billing_interval.charAt(0).toUpperCase() + formData.billing_interval.slice(1) : '-'} className={""} />
              </div>
              <div className="col-lg-5 col-md-5 col-sm-5 position-relative">
                <MessageLabel text="Billing Type" className={""} />
              </div>
              <div className="col-lg-1 col-md-1 col-sm-1 position-relative">
                <MessageLabel text=":" className={""} />
              </div>
              <div className="col-lg-6 col-md-6 col-sm-6 position-relative">
                <MessageSubHeading text={formData?.billing_type ? formData.billing_type.charAt(0).toUpperCase() + formData.billing_type.slice(1) : '-'} className={""} />
              </div>
              <div className="col-lg-5 col-md-5 col-sm-5 position-relative">
                <MessageLabel text="Price" className={""} />
              </div>
              <div className="col-lg-1 col-md-1 col-sm-1 position-relative">
                <MessageLabel text=":" className={""} />
              </div>
              <div className="col-lg-6 col-md-6 col-sm-6 position-relative">
                <MessageSubHeading text={`${formData?.currency || ''} ${formData?.price || '-'}`} className={"fw-bold"} />
              </div>

              {/* Display Secondary Currency Prices in Preview */}
              {defaultOption?.enable_secondary_currency == 1 && defaultOption?.secondary_currencies?.length > 0 && (
                <>
                  {defaultOption.secondary_currencies.map((code) => {
                    const price = formData?.secondary_prices?.[code];
                    const currObj = defaultOption?.currencyOption?.find((c) => c.code === code);
                    const displaySymbol = currObj?.symbol || code;

                    // Only show if a specific price is set, or visually indicate it inherits primary
                    return (
                      <React.Fragment key={`preview_secondary_${code}`}>
                        <div className="col-lg-5 col-md-5 col-sm-5 position-relative">
                          <MessageLabel text={`Price (${code})`} className={""} />
                        </div>
                        <div className="col-lg-1 col-md-1 col-sm-1 position-relative">
                          <MessageLabel text=":" className={""} />
                        </div>
                        <div className="col-lg-6 col-md-6 col-sm-6 position-relative">
                          <MessageSubHeading
                            text={price ? `${displaySymbol} ${typeof price === 'object' ? price?.amount : price}` : `-`}
                            className={price ? "fw-bold" : "font-italic opacity-50"}
                          />
                        </div>
                      </React.Fragment>
                    );
                  })}
                </>
              )}
              {formData?.ios_product_id && (
                <>
                  <div className="col-lg-5 col-md-5 col-sm-5 position-relative">
                    <MessageLabel text="IOS Product ID" className={""} />
                  </div>
                  <div className="col-lg-1 col-md-1 col-sm-1 position-relative">
                    <MessageLabel text=":" className={""} />
                  </div>
                  <div className="col-lg-6 col-md-6 col-sm-6 position-relative">
                    <MessageSubHeading text={formData?.ios_product_id ? formData.ios_product_id.charAt(0).toUpperCase() + formData.ios_product_id.slice(1) : '-'} className={""} />
                  </div>
                  <div className="col-lg-5 col-md-5 col-sm-5 position-relative">
                    <MessageLabel text="IOS Plan Price" className={""} />
                  </div>
                  <div className="col-lg-1 col-md-1 col-sm-1 position-relative">
                    <MessageLabel text=":" className={""} />
                  </div>
                  <div className="col-lg-6 col-md-6 col-sm-6 position-relative">
                    <MessageSubHeading text={formData?.ios_plan_price ? formData.ios_plan_price.charAt(0).toUpperCase() + formData.ios_plan_price.slice(1) : '-'} className={""} />
                  </div>
                </>
              )}
              {/* Google Pay Product ID */}
              {formData?.google_pay_product_id && (
                <>
                  <div className="col-lg-5 col-md-5 col-sm-5 position-relative">
                    <MessageLabel text="Google Pay Product ID" className={""} />
                  </div>
                  <div className="col-lg-1 col-md-1 col-sm-1 position-relative">
                    <MessageLabel text=":" className={""} />
                  </div>
                  <div className="col-lg-6 col-md-6 col-sm-6 position-relative">
                    <MessageSubHeading text={formData?.google_pay_product_id ? formData.google_pay_product_id.charAt(0).toUpperCase() + formData.google_pay_product_id.slice(1) : '-'} className={""} />
                  </div>
                  {/* Google Pay Plan Price */}
                  <div className="col-lg-5 col-md-5 col-sm-5 position-relative">
                    <MessageLabel text="Google Pay Plan Price" className={""} />
                  </div>
                  <div className="col-lg-1 col-md-1 col-sm-1 position-relative">
                    <MessageLabel text=":" className={""} />
                  </div>
                  <div className="col-lg-6 col-md-6 col-sm-6 position-relative">
                    <MessageSubHeading text={formData?.google_pay_plan_price ? formData.google_pay_plan_price.charAt(0).toUpperCase() + formData.google_pay_plan_price.slice(1) : '-'} className={""} />
                  </div>
                </>
              )}
              <div className="col-lg-5 col-md-5 col-sm-5 position-relative">
                <MessageLabel text="Payment Type" className={""} />
              </div>
              <div className="col-lg-1 col-md-1 col-sm-1 position-relative">
                <MessageLabel text=":" className={""} />
              </div>
              <div className="col-lg-6 col-md-6 col-sm-6 position-relative">
                <MessageSubHeading text={formData?.payment_type ? formData.payment_type.charAt(0).toUpperCase() + formData.payment_type.slice(1) : '-'} className={""} />
              </div>
              <div className="col-lg-5 col-md-5 col-sm-5 position-relative">
                <MessageLabel text="Plan Subscription Category" className={"text-info"} />
              </div>
              <div className="col-lg-1 col-md-1 col-sm-1 position-relative">
                <MessageLabel text=":" className={""} />
              </div>
              <div className="col-lg-6 col-md-6 col-sm-6 position-relative">
                <MessageSubHeading
                  text={
                    categoryOptions.find(c => c.value === Number(formData?.plan_category))?.name
                  }
                  className="text-info"
                />
              </div>
            </div>
            <div className="d-flex align-items-center gap-3 flex-wrap mt-4">
              {formData?.SubscriptionPlan_Name?.map((item) =>
                imageFind[item?.PaymentGateway_id] ? (
                  <img
                    src={imageFind[item?.PaymentGateway_id]}
                    className="logoPay rounded-3 theme-border-secondary"
                    alt={item?.PaymentGateway_id}
                  />
                ) : (<></>)
              )}
            </div>

          </Wrapper>
          <FormContainer>
            <LeftWrapper>
              <Wrapper>
                <MessageHeading text="Edit Plan" />
                <MessageLabel text={labelDisplay?.[4]?.title} className="mandatorySimple" />
                <AdminCustomInput type="text" name="plans_name" value={formData?.plans_name} onChange={handleInputUpdate} placeHolder={"Plan Name"} ref={(el) => (combinedRef.current.plans_name = el)} error={formDataError?.plans_name} />
                <MessageLabel text={labelDisplay?.[7]?.title} />
                <JoditEditor className="mb-3" ref={(el) => (combinedRef.current.plan_content = el)} value={formData?.plan_content} onChange={(newContent) => setFormData(prev => ({ ...prev, plan_content: newContent }))} />
                {formDataError?.plan_content && (<div className='d-flex align-items-center gap-1 mb-2'><IoMdInformationCircle className='errorred' style={{ width: "17px", height: "16px" }} /><MessageBox text={`${formDataError?.plan_content}`} classname='errorred  d-block' /></div>)}
                <MessageLabel text={labelDisplay?.[15]?.title} className="mandatorySimple" />
                <Select options={defaultOption?.resolutionOption} isMulti name="video_quality" onChange={handleMultiSelect} value={typeof formData?.video_quality === 'string' ? formData.video_quality.split(',').map((val) => defaultOption?.resolutionOption.find((opt) => opt.value === val)) : formData?.video_quality} ref={(el) => (combinedRef.current.video_quality = el)} className={`${formDataError?.video_quality && 'custom-input-error'} custom-select-multi custom-placeholder theme-text-color mb-3`} />
                {formDataError?.video_quality && (<div className='d-flex align-items-center gap-1 mb-2'><IoMdInformationCircle className='errorred' style={{ width: "17px", height: "16px" }} /><MessageBox text={`${formDataError?.video_quality}`} classname='errorred mb-2 d-block' /></div>)}

                {/* <MessageLabel text={labelDisplay?.[15]?.title} className="mandatorySimple" />
                <Select options={defaultOption?.resolutionOption} isMulti name={'video_quality'} onChange={handleMultiSelect} value={formData?.video_quality} ref={(el) => (combinedRef.current.video_quality = el)} className={`${formDataError?.video_quality && 'custom-input-error'} custom-select-multi custom-placeholder theme-text-color mb-3`} />
                {formDataError?.video_quality && (<MessageBox text={`${formDataError?.video_quality}`} classname='errorred mb-2 d-block' />)} */}


                {/* <div className="card p-3 mt-3">
                  <MessageHeading text="Additional Fields" />
                  {/* Custom fields removed */}
                {/* </div> */}
              </Wrapper>


              {/* Device Access Permissions Section - Edit Mode */}
              <Wrapper>
                <MessageHeading text="Device Access Permissions" />
                {defaultOption?.devicesOption?.map((device) => {
                  // Get current permissions from formData (already parsed in previewSubscriptionPlan)
                  const currentAccess = formData[`device_access_${device.id}`] || [];

                  // Convert to react-select format
                  const accessOptions = [
                    { value: 'screen_cast', label: 'screen cast' },
                    { value: 'download', label: 'download' }
                  ];

                  const selectedAccessValues = currentAccess
                    .map(val => accessOptions.find(opt => opt.value === val))
                    .filter(Boolean);

                  return (
                    <div key={`access_edit_${device.id}`} className="mb-3">
                      <MessageLabel text={device.devices_name} />
                      <Select
                        options={accessOptions}
                        isMulti
                        name={`device_access_${device.id}`}
                        value={selectedAccessValues}
                        onChange={(selectedOptions) => {
                          const selectedValues = selectedOptions ? selectedOptions.map(opt => opt.value) : [];

                          // Update the individual device permission field
                          setFormData(prev => {
                            const updated = {
                              ...prev,
                              [`device_access_${device.id}`]: selectedValues
                            };

                            // Also update the devices_access_control object
                            const newAccessObj = { ...prev.devices_access_control };
                            if (selectedValues.length > 0) {
                              newAccessObj[device.id.toString()] = selectedValues;
                            } else {
                              delete newAccessObj[device.id.toString()];
                            }
                            updated.devices_access_control = newAccessObj;

                            return updated;
                          });
                        }}
                        className="custom-select-multi custom-placeholder theme-text-color mb-2"
                        placeholder="Select Permissions"
                      />
                    </div>
                  );
                })}
              </Wrapper>

              {/* <Wrapper>
                <MessageHeading text="Dynamic Plan Options" />
                <div className="d-flex justify-content-between mb-2 ">
                  <div className="col-6 col-md-6 pe-2">
                    <MessageLabel text="Premium Content" />
                  </div>
                  <div className="col-6 col-md-6 ps-2 text-end">
                    <AdminSwitch name={'premium_content'} checked={formData?.premium_content == 1} onChange={handleInputUpdate} />
                  </div>
                </div>

                <div className="d-flex justify-content-between mb-2 ">
                  <div className="col-6 col-md-6 pe-2">
                    <MessageLabel text="Music" />
                  </div>
                  <div className="col-6 col-md-6 ps-2 text-end">
                    <AdminSwitch name={'music'} checked={formData?.music == 1} onChange={handleInputUpdate} />
                  </div>
                </div>

                <div className="d-flex justify-content-between mb-2 ">
                  <div className="col-6 col-md-6 pe-2">
                    <MessageLabel text="Live TV" />
                  </div>
                  <div className="col-6 col-md-6 ps-2 text-end">
                    <AdminSwitch name={'live_tv'} checked={formData?.live_tv == 1} onChange={handleInputUpdate} />
                  </div>
                </div>

                <div className="mb-2">
                  <MessageLabel text="Max Audio Quality" />
                  <AdminCustomInput type="text" name="max_audio_quality" value={formData?.max_audio_quality} onChange={handleInputUpdate} placeHolder="Enter audio quality (e.g. Stereo, Dolby)" />
                </div>

              </Wrapper> */}

              {/* ── Plan Based Video (edit) ──────────────────────────────── */}
              <Wrapper>
                <div className="d-flex justify-content-between mb-2">
                  <div className="col-8 pe-2">
                    <MessageHeading text="Plan Based Video" noMargin />
                    <p className="theme-text-color opacity-50 small mt-1 mb-0" style={{ fontStyle: 'italic' }}>
                      Restrict this plan to only hand-picked content
                    </p>
                  </div>
                  <div className="col-4 ps-2 text-end">
                    <AdminSwitch name="plan_based_video" checked={formData?.plan_based_video == 1} onChange={handleInputUpdate} />
                  </div>
                </div>

                {formData?.plan_based_video == 1 && (
                  <div className="mt-3">
                    {/* Content type filter chips */}
                    <MessageLabel text="Filter by content type" className="mb-2" />
                    <div className="d-flex flex-wrap gap-2 mb-3">
                      {CONTENT_TYPE_OPTIONS.map(opt => {
                        const isSelected = pbvSelectedTypes.includes(opt.value);
                        return (
                          <button key={opt.value} type="button"
                            className={`btn btn-sm rounded-pill d-flex align-items-center gap-1 ${isSelected ? 'button-bg-color theme-body-text-color' : 'btn-outline-secondary'}`}
                            onClick={() => handlePbvTypeToggle(opt.value)}>
                            {isSelected && <MdCheck style={{ width: '14px', height: '14px' }} />}
                            {opt.label}
                          </button>
                        );
                      })}
                    </div>

                    {/* Search box */}
                    <MessageLabel text="Search content to add" className="mb-1" />
                    <AdminCustomInput type="text" name="pbv_search_edit" value={pbvSearchQuery} onChange={handlePbvQueryChange} placeHolder="Type to search..." />

                    {/* Search results */}
                    {pbvSearchLoading && <p className="theme-text-color opacity-50 small mt-1">Searching…</p>}
                    {!pbvSearchLoading && pbvSearchResults.length > 0 && (
                      <div className="mt-2 rounded-3 overflow-hidden" style={{ border: '1px solid var(--border-color, #e2e8f0)', maxHeight: '200px', overflowY: 'auto' }}>
                        {pbvSearchResults.map(item => {
                          const isAdded = formData.plan_contents?.some(
                            c => c.source_id === item.id && c.source_type === item.source_type
                          );
                          return (
                            <div key={`${item.source_type}-${item.id}`}
                              className="d-flex align-items-center justify-content-between px-3 py-2"
                              style={{ borderBottom: '1px solid var(--border-color, #e2e8f0)', cursor: 'pointer' }}
                              onClick={() => handleAddPbvContent(item)}>
                              <div className="d-flex align-items-center">
                                <span className="theme-text-color small">{item.title}</span>
                                <span className="theme-text-color small opacity-50 ms-1">— {sourceTypeLabel(item.source_type)}</span>
                              </div>
                              {isAdded && (
                                <MdCheck style={{ width: '16px', height: '16px', flexShrink: 0, color: 'var(--button-color)' }} />
                              )}
                            </div>
                          );
                        })}
                      </div>
                    )}

                    {/* Selected content chips */}
                    {formData.plan_contents?.length > 0 && (
                      <div className="mt-3">
                        <MessageLabel text={`Selected content (${formData.plan_contents.length})`} className="mb-2" />
                        <div className="d-flex flex-wrap gap-2">
                          {formData.plan_contents.map(item => (
                            <span key={`${item.source_type}-${item.source_id}`}
                              className="badge d-flex align-items-center gap-1 rounded-pill px-3 py-2"
                              style={{ background: 'var(--button-color)', color: 'var(--body-text-color)', fontSize: '12px' }}>
                              <span>{item.title}</span>
                              <small className="opacity-75">({sourceTypeLabel(item.source_type)})</small>
                              <MdOutlineRemoveCircle style={{ cursor: 'pointer', width: '14px', height: '14px' }}
                                onClick={() => handleRemovePbvContent(item.source_id, item.source_type)} />
                            </span>
                          ))}
                        </div>
                      </div>
                    )}
                  </div>
                )}
              </Wrapper>
              {/* ── End Plan Based Video (edit) ──────────────────────────── */}

            </LeftWrapper>
            <RightWrapper>

              {(formData?.stripe_enable == 1 || formData?.razorpay_enable == 1) && formData?.payment_type !== 'one_time' && (
                <Wrapper>
                  <div className="mb-3">
                    <MessageHeading text="Plan Trial Settings" noMargin />
                    <p className="theme-text-color opacity-50 small mt-1 mb-0" style={{ fontStyle: 'italic' }}>
                      (Only for Stripe & Razorpay payment gateways)
                    </p>
                  </div>
                  <div className="d-flex justify-content-between mb-2 ">
                    <div className="col-6 col-md-6 pe-2">
                      <MessageLabel text={labelDisplay?.[10]?.title} />
                    </div>
                    <div className="col-6 col-md-6 ps-2 text-end">
                      <AdminSwitch name={'plan_trail_status'} checked={formData?.plan_trail_status == 1} onChange={handleInputUpdate} />
                    </div>
                  </div>

                  {formData?.plan_trail_status == 1 && (<>
                    <MessageLabel text={labelDisplay?.[14]?.title} className="mandatorySimple" />
                    <AdminCustomInput min={0} type="number" id="plan-trail-days" name="plan_trail_days" value={formData?.plan_trail_days != null ? formData.plan_trail_days : ''} onChange={handleInputUpdate} placeHolder={"Plan Trail Days"} ref={(el) => (combinedRef.current.plan_trail_days = el)} error={formDataError?.plan_trail_days} />
                  </>)}
                </Wrapper>
              )}

              {(formData?.stripe_enable == 1 || formData?.razorpay_enable == 1) && (
                <Wrapper>
                  <MessageHeading text="Coupon Settings" />
                  <MessageSubHeading text="Select which payment gateways allow coupon / promo codes on this plan." />
                  <div className="d-flex flex-column gap-2 mt-2">
                    {formData?.stripe_enable == 1 && (
                      <label className="d-flex align-items-center gap-2" style={{ cursor: 'pointer' }}>
                        <input
                          type="checkbox"
                          checked={Array.isArray(formData?.coupon_gateways) && formData.coupon_gateways.includes(1)}
                          onChange={() => handleCouponGatewayToggle(1)}
                          style={{ width: '18px', height: '18px', cursor: 'pointer', accentColor: '#63CAB7' }}
                        />
                        <img src={stripe_image} alt="Stripe" style={{ height: '20px', objectFit: 'contain' }} />
                        <MessageLabel text="Stripe" className="mb-0" />
                      </label>
                    )}
                    {formData?.razorpay_enable == 1 && (
                      <label className="d-flex align-items-center gap-2" style={{ cursor: 'pointer' }}>
                        <input
                          type="checkbox"
                          checked={Array.isArray(formData?.coupon_gateways) && formData.coupon_gateways.includes(2)}
                          onChange={() => handleCouponGatewayToggle(2)}
                          style={{ width: '18px', height: '18px', cursor: 'pointer', accentColor: '#63CAB7' }}
                        />
                        <img src={razorpay_image} alt="Razorpay" style={{ height: '20px', objectFit: 'contain' }} />
                        <MessageLabel text="Razorpay" className="mb-0" />
                      </label>
                    )}
                  </div>
                </Wrapper>
              )}

              <Wrapper>
                <MessageHeading text={labelDisplay?.[8]?.title} />
                <div className="d-flex justify-content-between mb-2 ">
                  <div className="col-6 col-md-6 pe-2">
                    <MessageLabel text={labelDisplay?.[9]?.title} />
                  </div>
                  <div className="col-6 col-md-6 ps-2 text-end">
                    <AdminSwitch name={'ads_status'} checked={formData?.ads_status == 1} onChange={handleInputUpdate} />
                  </div>
                </div>

                <div className="d-flex justify-content-between mb-2 ">
                  <div className="col-6 col-md-6 pe-2">
                    <MessageLabel text="Active Status" />
                  </div>
                  <div className="col-6 col-md-6 ps-2 text-end">
                    <AdminSwitch name={'status'} checked={formData?.status == 1} onChange={handleInputUpdate} />
                  </div>
                </div>
              </Wrapper>



              {/* Source Types with Common Days Section - Edit Mode */}
              <Wrapper>
                <MessageHeading text="Restriction Time Period (New Release)" />
                <MessageLabel text="Select Source Types" className="" />
                <Select
                  options={defaultOption?.sourceTypesOption}
                  isMulti
                  name="selected_source_types"
                  onChange={handleSourceTypeSelect}
                  value={formData?.selected_source_types || []}
                  className="custom-select-multi custom-placeholder theme-text-color mb-3"
                  placeholder="Select Source Types"
                />
                {formDataError?.selected_source_types && (
                  <MessageBox text={formDataError.selected_source_types} classname="errorred mb-2 d-block" />
                )}

                {/* Common days input for all selected source types */}
                {formData?.selected_source_types?.length > 0 && (
                  <div className="mb-3">
                    <MessageLabel text="Days (Applies to all selected source types)" className="" />
                    <AdminCustomInput
                      type="number"
                      name="common_days"
                      value={formData.common_days || ''}
                      onChange={(e) => handleCommonDaysChange(e.target.value)}
                      placeHolder="Enter number of days"
                      min={1}
                      error={formDataError.common_days}
                    />
                  </div>
                )}

                {/* Show selected source types */}
                {formData?.selected_source_types?.length > 0 && (
                  <div className="mb-3">
                    <MessageLabel text="Selected Source Types:" className="mb-2" />
                    <div className="d-flex flex-wrap gap-2">
                      {formData.selected_source_types.map((sourceType) => (
                        <span key={sourceType.value} className="badge bg-primary">
                          {sourceType.label}
                        </span>
                      ))}
                    </div>
                  </div>
                )}
              </Wrapper>

              <Wrapper>
                <MessageHeading text={labelDisplay?.[22]?.title} className="" />
                <MessageLabel text={"Select Device restrict type"} />
                <AdminCustomSelect name='devices' value={formData?.devices} options={formData?.defaultDeviceLimitOptions} onChange={handleInput} defaultOptionName={'Select Device Restriction Option'} />
                {formData?.devices === "total_limit" ?
                  <AdminCustomInput name="devices_count" min={1} max={99} type="number" value={formData?.devices_count} onChange={handleInput} placeHolder="Enter the device count" />
                  : formData?.devices === "platform_device_combination" ?
                    <>
                      <Select
                        ref={(el) => (combinedRef.current.destination_rtmp = el)}
                        options={formData?.individualDevicesList}
                        isMulti
                        name="individual_platoforms_combination"
                        value={formData?.individualDevicesList?.map(item => formData?.individual_platoforms_combination?.find(val => val?.value === item?.value))}
                        onChange={handleMultiSelect}
                        className={`custom-select-multi custom-input-border custom-placeholder bg-transparent theme-text-color w-100 mb-3 p-3`}
                        placeholder="Select Devices"
                      />
                      <AdminCustomInput name="devices_count" min={1} max={99} type="number" value={formData?.devices_count} onChange={handleInput} placeHolder="Enter the device count" />

                    </>
                    : formData?.devices === "individual_limit" && (
                      <>
                        <MessageSubHeading className={'px-2'} text="Laptop/Desktop" />
                        <AdminCustomInput value={formData?.individual_limits?.web} name='web' min={1} max={99} type="number" placeHolder="Enter the Web count" onChange={handleDeviceLimitChange} />
                        <MessageSubHeading className={'px-2'} text="Mobile" />
                        <AdminCustomInput value={formData?.individual_limits?.mobile} name='mobile' min={1} max={99} type="number" placeHolder="Enter the Mobile count" onChange={handleDeviceLimitChange} />
                        <MessageSubHeading className={'px-2'} text="Tablet" />
                        <AdminCustomInput value={formData?.individual_limits?.tablet} name='tablet' min={1} max={99} type="number" placeHolder="Enter the Tablet count" onChange={handleDeviceLimitChange} />
                        <MessageSubHeading className={'px-2'} text="TV" />
                        <AdminCustomInput value={formData?.individual_limits?.tv} name='tv' min={1} max={99} type="number" placeHolder="Enter the TV count" onChange={handleDeviceLimitChange} />
                      </>
                    )}
              </Wrapper>



            </RightWrapper>
          </FormContainer>
        </>
      }
    </>
  );
};

export default AddSubscriptionPlan;